import InnerPageCAds from './InnerPageCAds';
export default InnerPageCAds;
